import { Stack, Typography } from "@mui/material";
import React from "react";
import { fonts } from "fonts";
import { useTheme } from "@emotion/react";

export default function NoActiveTalk() {

  const theme = useTheme();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <Typography
        fontFamily={fonts.anton}
        sx={{
          color: theme.palette.text.main,
        }}
      >
        Select a friend to view conversation
      </Typography>
    </Stack>
  );
}
